module.exports = __webpack_public_path__ + "img/avatar2.ea69e15d.png";